"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getCurrentClipIndex;

function getCurrentClipIndex(clips, currentClip) {
  return clips.findIndex(function (clip) {
    return clip.startTime === currentClip.startTime;
  });
}